export default "__VITE_PUBLIC_ASSET__b6c918cc__"